import { render } from "./copy_right.vue?vue&type=template&id=347f0f8b"
import script from "./copy_right.vue?vue&type=script&lang=js"
export * from "./copy_right.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__